<template>
  <div v-if="geneDatas" class="case-detail-region-gene-data-page col-block width-full" :style="{ flex: 1 }">
    <div class="region-gene-data-main-container col-block width-full" :style="{ flex: 1 }">
      <div ref="gene-data-scroll" class="region-gene-data-main-list-container col-block width-full" :style="{ flex: 1 }">
        <div class="region-gene-data-main-list-block" :style="{ height: 0 }">
          <div class="region-gene-data-main-data-container" v-for="(geneData, gdindex) in geneDatas" :key="gdindex">
            <overlappingGeneData
              :dataList="geneDatas"
              :dataIndex="gdindex"
              :geneData="geneData"
            ></overlappingGeneData>
          </div>
        </div>
      </div>
      <div v-if="pageData" class="region-gene-data-page-container row-block">
        <div :style="{ width: '10px' }"></div>
        <div class="region-gene-data-page-total">{{ $t('COMPONENT.caseDetail.regionGeneData.page.___total', { total: toPriceString(pageData.total) }) }}</div>
        <div :style="{ flex: 1 }"></div>
        <div class="region-gene-data-page-display">{{ $t('COMPONENT.caseDetail.regionGeneData.page.___display', { display: pageData.display }) }}</div>
        <div :style="{ width: '20px' }"></div>
        <pageButtons
          :default="pageData.selectedPage"
          :display="pageData.display - 0"
          :total="pageData.total"
          :buttonRange="pageData.buttonRange"
          @selectPage="page => { pageData.selectedPage = page; searchDatas() }"
        ></pageButtons>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { getCaseProjectRegionGeneTable, getCaseProjectRegionGene } from '../../api'
import overlappingGeneData from './regionOverlappingGeneData.vue'
import pageButtons from '../tool/pageButtons.vue'
import routeLoading from '../../mixins/routeLoading.vue'
import { getRegionOrphaPhenotypeList, getRegionPhenotypeList } from '../../constants/global/data'
import { toPriceString } from '../../constants/global/util'
import { _LOCAL_BUILD } from '../../constants/global/config'

export default {
  components: {
    overlappingGeneData,
    pageButtons
  },
  mixins: [
    routeLoading
  ],
  props: {
    svID: {
      type: String,
      required: true
    },
    caseData: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      geneDatas: null,
      pageData: {
        selectedPage: 1,
        display: 20,
        total: 0,
        buttonRange: 7
      }
    }
  },
  computed: {
    // global
    toPriceString () { return toPriceString }
  },
  methods: {
    ...mapActions([
      'setLoadingAction'
    ]),
    async fetchData () {
      await this.fetchOverlappingGenes(true)
    },
    async fetchOverlappingGenes (reset = false) {
      try {
        let config = this.$ls.get('userInfo')
        let id = this.caseData.id
        let projectID = this.project.id
        let svID = this.svID
        let response = null
        // table
        if (!this.tableName) {
          let tableData = {}
          response = await getCaseProjectRegionGeneTable(id, projectID, tableData, config)
          let tableName = !_LOCAL_BUILD ? response.data.data.table_name : response.data.data.session
          this.tableName = tableName
        }
        // query
        reset && (this.pageData.selectedPage = 1)
        let data = {
          table_name: this.tableName,
          session: this.tableName,
          limit: 20,
          page: this.pageData.selectedPage
        }
        response = await getCaseProjectRegionGene(id, projectID, svID, data, config)
        let geneDatas = response.data.data.data
        // data
        const phenotypeMetadatas = {
          'true': {
            getListFunciton: getRegionPhenotypeList
          },
          'false': {
            getListFunciton: getRegionOrphaPhenotypeList
          }
        }
        geneDatas = geneDatas.map(regionData => {
          return {
            ...regionData,
            phenotypeDatas: phenotypeMetadatas[!regionData.gene_name.startsWith('MT-')].getListFunciton(regionData)
          }
        })
        reset && (this.pageData.total = response.data.data.total_count - 0)
        this.geneDatas = geneDatas
      } catch (error) {
        throw error
      }
    },
    async searchDatas () {
      this.setLoadingAction(true)
      await this.fetchOverlappingGenes()
      this.$refs['gene-data-scroll'].scrollTop = 0
      this.setLoadingAction(false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/caseDetail/regionGeneData.vue